export const defaultState = {
	name: '',
	account: '',
	regions: [],
	regions_count: null,
	roles: [],
	isToggle: true,
	lastDetailRequest: 0
}
